import * as React from 'react';
import React__default from 'react';
import { getCategoryByID } from '@sbt-web/category-utils';
import { CategoryId } from '@sbt-web/networking';
import cn from 'classnames';
import { LayoutScale } from '@sbt-web/ui';

function buildBreadcrumbs(data) {
    const links = [];
    links.push({ url: new URL(data.origin).toString(), label: 'Subito' });
    const adTypeLabel = data.adTypeData.label;
    const adTypeParameterName = data.adTypeData.parameterName;
    const category = getCategoryByID(data.categoryId);
    const builder = new URL(`/annunci-italia/${adTypeParameterName}/${category.friendly}/`, data.origin);
    links.push({
        url: builder.toString(),
        label: data.categoryId === CategoryId.Tutte
            ? adTypeLabel
            : `${category.label[0].toUpperCase()}${category.label
                .slice(1)
                .toLowerCase()}`,
    });
    if (data.categoryId === CategoryId.Moto && data.vehicleData?.for === 'moto') {
        const vehicleData = data.vehicleData;
        if (vehicleData.brand && vehicleData.model && vehicleData.type) {
            delete vehicleData.type;
        }
        if (vehicleData.brand) {
            builder.searchParams.set(vehicleData.brand.parameterName, vehicleData.brand.id);
            links.push({
                url: builder.toString(),
                label: `${vehicleData.brand.label[0].toUpperCase()}${vehicleData.brand.label
                    .slice(1)
                    .toLowerCase()}`,
            });
        }
        if (vehicleData.model) {
            builder.searchParams.set(vehicleData.model.parameterName, vehicleData.model.id);
            links.push({
                url: builder.toString(),
                label: vehicleData.model.label,
            });
        }
        if (vehicleData.type) {
            builder.searchParams.set(vehicleData.type.parameterName, vehicleData.type.id);
            links.push({
                url: builder.toString(),
                label: vehicleData.type.label,
            });
        }
    }
    else if (data.categoryId === CategoryId.Auto &&
        data.vehicleData?.for === 'auto') {
        const vehicleData = data.vehicleData;
        if (vehicleData.brand) {
            builder.pathname += `${vehicleData.brand.value}/`;
            links.push({
                url: builder.toString(),
                label: `${vehicleData.brand.label[0].toUpperCase()}${vehicleData.brand.label
                    .slice(1)
                    .toLowerCase()}`,
            });
        }
        if (vehicleData.model) {
            builder.pathname += `${vehicleData.model.value}/`;
            links.push({
                url: builder.toString(),
                label: vehicleData.model.label,
            });
        }
        if (vehicleData.type) {
            builder.pathname += `${vehicleData.type.value}/`;
            links.push({
                url: builder.toString(),
                label: vehicleData.type.label,
            });
        }
        if (vehicleData.fuel) {
            builder.pathname += `${vehicleData.fuel.value}/`;
            links.push({
                url: builder.toString(),
                label: vehicleData.fuel.label,
            });
        }
    }
    const geo = data.geo;
    if (geo) {
        // The first element is empty, since the pathname starts with a string.
        // The second element is 'annunci-italia' which we ignore here.
        const [, adTypePart, categoryPart, ...specificParts] = builder.pathname
            .split('/')
            .slice(1, -1);
        const regionPart = `annunci-${geo.region.friendlyName}`;
        builder.pathname = `/${[
            regionPart,
            adTypePart,
            categoryPart,
            ...specificParts,
        ].join('/')}/`;
        links.push({
            url: builder.toString(),
            label: geo.region.value,
        });
        const city = geo.city;
        if (city) {
            builder.pathname = `/${[
                regionPart,
                adTypePart,
                categoryPart,
                city.friendlyName,
                ...specificParts,
            ].join('/')}/`;
            links.push({
                url: builder.toString(),
                label: `${city.value} (Prov)`,
            });
            const town = geo.town;
            if (town) {
                builder.pathname = `/${[
                    regionPart,
                    adTypePart,
                    categoryPart,
                    city.friendlyName,
                    town.friendlyName,
                    ...specificParts,
                ].join('/')}/`;
                links.push({
                    url: builder.toString(),
                    label: town.value,
                });
            }
        }
    }
    const searchQuery = data.searchQuery;
    if (searchQuery) {
        const encodedQuery = searchQuery.toLowerCase();
        builder.searchParams.set('q', encodedQuery);
        links.push({
            url: builder.toString(),
            label: searchQuery,
        });
    }
    return links;
}

var style = {"container":"index-module_container__rA-Ps","not-navigable-item":"index-module_not-navigable-item__1nfCo"};

function Breadcrumbs({ assetsBase, breadcrumbs, classes = [], }) {
    if (!breadcrumbs) {
        return null;
    }
    return (React.createElement("ol", { className: cn(style['container'], classes), itemScope: true, itemType: "https://schema.org/BreadcrumbList" }, breadcrumbs.map((breadcrumb, index) => (React.createElement("li", { key: `${breadcrumb.url}${index}`, itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/ListItem" },
        breadcrumb.url ? (React.createElement("a", { href: breadcrumb.url, itemProp: "item" },
            React.createElement("span", { itemProp: "name" }, breadcrumb.label))) : (React.createElement("span", { className: style['not-navigable-item'], itemProp: "name" }, breadcrumb.label)),
        React.createElement("meta", { itemProp: "position", content: (index + 1).toString() }),
        index !== breadcrumbs.length - 1 ? (React.createElement("img", { src: `${assetsBase}/static/icons/cactus/arrow-right.svg`, width: LayoutScale.XXS, height: LayoutScale.XXS, alt: "", crossOrigin: "anonymous" })) : undefined)))));
}

const useBreadcrumbForAd = (data) => {
    let breadcrumbs;
    try {
        breadcrumbs = buildBreadcrumbs(data);
    }
    catch (err) {
        console.error('Error while generating breadcrumbs:', err);
    }
    return {
        breadcrumbs: (React__default.createElement(Breadcrumbs, { assetsBase: data.assetsBase, breadcrumbs: breadcrumbs })),
    };
};

export { Breadcrumbs, useBreadcrumbForAd };
//# sourceMappingURL=index.js.map
